import { ODataV4Adaptor } from "@syncfusion/ej2-data";

export class WebApiV4Adaptor extends ODataV4Adaptor {
  onPredicate(predicate, query) {
    if (!predicate) {
      return super.onPredicate(predicate, query);
    }

    const operators = {
      greaterthan: "gt",
      greaterthanorequal: "ge",
      lessthan: "lt",
      lessthanorequal: "le",
      equal: "eq",
      notequal: "ne"
    };

    const { field, operator } = predicate;
    let { value } = predicate;

    if (field === "IsExtendedTaxDeadline") {
      value = value.toLowerCase();
      return `ExtendedTaxDeadline ${value === "yes" ? "ne" : "eq"} null`;
    }

    if (field === "FilingStatus") {
      const filingStatuses = {
        1: "Filed",
        2: "NotFiled",
        3: "WaitingForResponse",
        4: "Error",
        5: "Unknown",
        null: null
      };

      return `FilingStatus ${operators[operator]} '${filingStatuses[value]}'`;
    }

    if (field === "Tags" || field === "Collaborators") {
      if (operator === "contains")
        return `${field}/any(t: contains(t, '${value}'))`;
      if (operator === "doesnotcontain")
        return `${field}/all(t: not contains(t, '${value}'))`;
      if (operator === "notequal")
        return `${field}/all(t: t ${operators[operator]} '${value}')`;
      else return `${field}/any(t: t ${operators[operator]} '${value}')`;
    }

    return super.onPredicate(predicate, query);
  }

  onEachSort(e) {
    if (e.name === "Tags") {
      e.name = "TagString";
    }
    if (e.name === "Collaborators") {
      e.name = "CollaboratorString";
    }
    return super.onEachSort(e);
  }

  // Parses legacy OData v3 "/Date(nnn)/" strings into Date objects for any field
  // whose value matches that pattern. The format is OData-specific and cannot
  // occur as a user-entered string, so matching by value shape is safe — unlike
  // dateParse=true which also matches ISO strings like "2022-06-22" that could
  // legitimately be non-date data (e.g. a folder name).
  _parseDateFields(items) {
    if (!Array.isArray(items)) return items;
    const legacyDate = /^\/Date\((-?\d+)\)\/$/;
    return items.map((item) => {
      if (!item || typeof item !== "object") return item;
      const converted = { ...item };
      for (const key of Object.keys(converted)) {
        const val = converted[key];
        if (typeof val === "string") {
          const m = legacyDate.exec(val);
          if (m) converted[key] = new Date(Number(m[1]));
        }
      }
      return converted;
    });
  }

  processResponse(data, ds, query, xhr, request) {
    var pvtData = "pvtData";
    var pvt = request && request[pvtData];

    var count = null;
    var args = {};

    if (request && request.type.toLowerCase() !== "post") {
      if (query && query.isCountRequired) {
        if (data.Count) {
          count = data.Count;
        } else if (data.count) {
          count = data.count;
        }
      }

      if (data.Items) {
        data = this._parseDateFields(data.Items);
      } else if (data.items) {
        data = this._parseDateFields(data.items);
      } else if (Array.isArray(data)) {
        data = this._parseDateFields(data);
      }

      args.count = count;
      args.result = data;

      this.getAggregateResult(pvt, data, args, null, query);
    }

    args.result = args.result || data;

    return !count
      ? args.result
      : { result: args.result, count: args.count, aggregates: args.aggregates };
  }
}
